Vendd.Scripts.load(function () {
    var $form = $('.x-custom-form'), form, formData, files = [], sentConsents = false, submitted = false;

    if ($form.length < 1) return;

    form = $form.get(0);

    formData = {
        name: $("input[name='name']", $form).val() ? $("input[name='name']", $form).val() : "",
        email: $("input[name='email']", $form).val() ? $("input[name='email']", $form).val() : "",
        phone: $("input[name='phone']", $form).val() ? $("input[name='phone']", $form).val() : "",
        radio: $("input[name='radio']", $form).val() ? $("input[name='radio']", $form).val() : "",
        checkbox: $("input[name='checkbox']", $form).prop("checked") ? true : false,
        dropdown: $("select[name='dropdown']", $form).val() ? $("select[name='dropdown']", $form).val() : "",
        files: []
    };

  

    // reCAPTCHA
    var reCaptchaCode;
    var captchaId = "customFormCaptcha";
    var captchaWidgetId;
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    //file upload
    var $fileUploadElement = $("#cwfileupload", $form);
    var fileUploadEnabled = $fileUploadElement.length > 0 ? true : false;
    var invalidUpload = false;
    var fileUploadStep = 0;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
            //accessibility fix
            $('#g-recaptcha-response').attr('aria-label', 'recaptcha response');
        }
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.validateFileUpload = function () {
        if (!fileUploadEnabled)
            return true;

        if (invalidUpload)
            return false;

        if ($("#cwfileupload", $form).data("mandatoryfileupload") === "True" && files.length === 0) {
            $('.cwfileupload-required', $form).show();
            $('.form-row.file', $form).addClass('with-error');

            return false;
        }

        return true;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {

        if (!submitted) return;

        form.loading(false);

        var data = envelope.message.data;

        if (data.Success) {
            $('.js-error', $form).hide();
            $('.js-generic-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();

            $('html,body').animate({ scrollTop: $form.offset().top - 80 }, 400);

            form.removeRecaptcha();
            form.reset();
        } else {

            if (envelope.message.data.Errors) {
                $('.js-error', $form).text(envelope.message.data.Errors[0]).show();
            } else {
                $('.js-generic-error', $form).show();
            }
            
            $('html,body').animate({ scrollTop: $form.offset().top - 80 }, 400);
            form.resetRecaptcha();
        };
        submitted = false;
    };

    form.onFailure = function (envelope) {

        if (!submitted) return;

        form.loading(false);

        if (envelope.message.data.Errors) {
            $('.js-error', $form).text(envelope.message.data.Errors[0]).show();
        } else {
            $('.js-generic-error', $form).show();
        }
        
        $('html,body').animate({ scrollTop: $form.offset().top - 80 }, 400);
        form.resetRecaptcha();
        submitted = false;
    };

    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox', $form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Custom Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            sentConsents = true;
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    };

    form.submit = function () {
        form.loading(true);

        formData.checkbox = $("input[name='checkbox']", $form).prop("checked");
        formData.radio = $('input[name=radio]:checked', $form).val() ? $('input[name=radio]:checked', $form).val() : '';
        formData.dropdown = $('select option:selected').val() ? $('select option:selected').val() : '';

        $('input:not([type="checkbox"],[type="radio"],[type="file"]), textarea:not([name="g-recaptcha-response"])', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        var code = $form.data("code");
        var widgetCode = $form.data("item-code");
        var model = formData;

        var data = { model: model, code: code, widgetCode: widgetCode, useReCaptcha: reCaptchaCode };

        if (files.length > 0) {
            //init files array
            formData.files = [];

            $.each(files, function (index, file) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onerror = function (error) { console.log('Error: ', error); };
                reader.onload = function () {
                    formData.files.push({ name: file.name, fileData: reader.result });
                    if (index == (files.length - 1)) {
                        submitted = true;
                        Vendd.MessageBus.publishAsync('CustomForm', new Vendd.CustomForms.Messages.Submit(data));
                    }
                };
            });
        } else {
            submitted = true;
            Vendd.MessageBus.publishAsync('CustomForm', new Vendd.CustomForms.Messages.Submit(data));
        }
    };

    form.reset = function () {
        $('input[name="name"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="phone"]', $form).val("");
        $('input[name="radio"]:first', $form).prop('checked', true);
        $('input[name="checkbox"]', $form).prop('checked', false);
        $('select[name="dropdown"]', $form).val("");

        $('input[name="TermsOfUse"]', $form).prop('checked', false);

        //empty array of files
        files = [];
        fileUploadStep = 0;

        cf.reset();
    };

    form.clearUploadErrors = function () {
        $('.cwfileupload-required', $form).hide();
        $('.cwfileupload-invalid', $form).hide();
        $('.cwfileupload-exceeds-max-size', $form).hide();
        $('.form-row.file', $form).removeClass('with-error');
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = cf.validate();
        var val2 = form.validateRecaptcha();
        var val3 = form.validateFileUpload();

        if (val1 && val2 && val3) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                form.submit();
            }

        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error').first().offset().top - 100 }, 400);
            }
        }

        initialValidation = true;
    });

    $form.on('blur', 'input[name]:not([type="checkbox"],[type="radio"],[type="file"]), textarea[name]', function (e) {
        //validate fields instantly
        if (!initialValidation) {
            if ($(this).attr('name') === "email") {
                cf.validateField("email");
            }

            if ($(this).attr('name') === "phone") {
                cf.validateField("phone");
            }

            if ($(this).attr('name') === "mobilephone") {
                cf.validateField("mobilephone");
            }
        }

        form.setField($(this));
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"],[type="radio"],[type="file"]), textarea[name]', function (e) {
        form.setField($(this));
    });

    $form.on('change', 'select[name], input[name][type="radio"]', function (e) {
        form.setField($(this));
    });

    $form.on('click', '.js-delete-file', function (e) {
        e.preventDefault();

        var $file = $(this).parent();
        var fileIndex = $file.index();

        //remove html element
        $file.remove();
        //remove row from array
        files.splice(fileIndex, 1);

        form.clearUploadErrors();
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        cf.validate(fieldName);
    };

    //init validation options
    var validationOptions = {}, initialValidation = false;

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        validationOptions[inputName] = { required: inputName + '-required' };
    });

    //add consent validations
    $.each($('div.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = { checkboxRequired: consentType + '-required' };
    });

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        validationOptions.email = validationOptions.email || {};
        validationOptions.email = { ...validationOptions.email, ...{ isEmail: 'email-invalid' } };
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        validationOptions.phone = validationOptions.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            validationOptions.phone = { ...validationOptions.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } } };
        } else {
            validationOptions.phone = { ...validationOptions.phone, ...{ isPhoneNumber: 'phone-invalid' } };
        }
    }

    $form.validationEngine(validationOptions);
    var cf = $form.data('validationEngine');

    if ($(".view-terms", $form).length > 0) {
        $(".view-terms", $form).fancybox({
            touch: false,
            autoFocus: false
        });
    }

    var $consents = $('.form-row.consent input[type="checkbox"]', $form);

    $consents.on('click', function () {
        var fieldName = $(this).attr('name');

        cf.validate(fieldName);
    });

    $('.cwfileupload', $form).fileupload({
        autoUpload: false,
        singleFileUploads: true,
        fileInput: $("input:file"),
        add: function (e, data) {

            form.clearUploadErrors();

            var maxFileSize = $("#cwfileupload", $form).data("maxfilesize");
            var fileTypes = $("#cwfileupload", $form).data("acceptfiletypes");
            fileTypes = fileTypes.replace(/\,./g, '|');

            if (fileTypes) {
                var acceptFileTypes = "(\.|\/)(" + fileTypes + ")$";
                acceptFileTypes = new RegExp(acceptFileTypes, "i");
            }
            var extractExtension = /(?:\.([^.]+))?$/;

            if (acceptFileTypes && data.files[0]['type'].length > 0 && !acceptFileTypes.test(extractExtension.exec(data.files[0].name)[0])) {
                invalidUpload = true;
                $('.cwfileupload-invalid', $form).show();
                $('.form-row.file', $form).addClass('with-error');
            } else if (acceptFileTypes && data.files[0]['type'].length < 1) {
                invalidUpload = true;
                $('.cwfileupload-invalid', $form).show();
                $('.form-row.file', $form).addClass('with-error');
            } else if (data.files[0]['size'] > maxFileSize) {
                invalidUpload = true;
                $('.cwfileupload-exceeds-max-size', $form).show();
                $('.form-row.file', $form).addClass('with-error');
            }  else {
                files.push(data.files[0]);
                fileUploadStep = fileUploadStep + 1;
                invalidUpload = false;

                var html = ' <div class="cwuploaded-file icon-attachment" data-vtest="cwUploadIcon' + fileUploadStep + '"><span class="text" data-vtest="cwUploadText' + fileUploadStep + '">' + data.files[0].name + '</span><span class="js-delete-file cwdelete-file icon-exit-big" data-vtest="cwUploadDelete' + fileUploadStep +'"></span></div>'
                $('.js-uploaded-files', $form).append(html);
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.SubmitFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);
    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, function () {
        if (sentConsents) {
            sentConsents = false;
            form.submit();     
        }
    });
});